import "../styles/blocks/privacy-policy/privacy-policy.scss";

import React, {useEffect} from 'react';

import DefaultLayout from '../layouts/DefaultLayout';
import DefaultHelmet from '../seo/DefaultHelmet';
import PageHeader from '../components/PageHeader';

const TermsPage = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const script = document.createElement('script');
    script.src = 'https://cdn.iubenda.com/iubenda.js';
    script.async = true;
    script.type = 'text/javascript';

    document.body.appendChild(script);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return (
    <DefaultLayout isHeaderWithBlackText={true}>
      <DefaultHelmet
        title="Terms and Conditions"
        description="Terms and Conditions"
      />

      <PageHeader title="Terms and Conditions" isGeneral={true} />

      <div className="container privacy-policy">
        <a
          href="https://www.iubenda.com/terms-and-conditions/40829989"
          className="iubenda-nostyle iubenda-noiframe iubenda-embed iub-body-embed"
          title="Terms and Conditions"
        >
          Terms and Conditions
        </a>
      </div>
    </DefaultLayout>
  );
};

export default TermsPage;
